var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScissors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 56.25C47.8553 56.25 56.25 47.8553 56.25 37.5C56.25 27.1447 47.8553 18.75 37.5 18.75C27.1447 18.75 18.75 27.1447 18.75 37.5C18.75 47.8553 27.1447 56.25 37.5 56.25Z",
    stroke: "#D9F5E7",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 131.25C47.8553 131.25 56.25 122.855 56.25 112.5C56.25 102.145 47.8553 93.75 37.5 93.75C27.1447 93.75 18.75 102.145 18.75 112.5C18.75 122.855 27.1447 131.25 37.5 131.25Z",
    stroke: "#D9F5E7",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125 25L50.75 99.25",
    stroke: "#D9F5E7",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4375 90.5L125 125",
    stroke: "#D9F5E7",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.75 50.75L75 75",
    stroke: "#D9F5E7",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScissors);
export default __webpack_public_path__ + "static/media/scissors.8eeba77fe63a6d052b947f292737e14a.svg";
export { ForwardRef as ReactComponent };